export const macOSPlatforms = [
    'Macintosh',
    'MacIntel',
    'MacPPC',
    'Mac68K',
    'iPad',
    'iPhone',
];
